module.exports = __webpack_public_path__ + "static/media/ic_camera.c796b0a3.png";